import service from '@/utils/request'

export function finalExamGradeList(data) {
  return service({
    url: '/api/final_exam/grade/list',
    method: 'post',
    data
  })
}

export function finalExamGradeAdd(data) {
  return service({
    url: '/api/final_exam/grade/add',
    method: 'post',
    data
  })
}

export function finalExamGradeEdit(data) {
  return service({
    url: '/api/final_exam/grade/edit',
    method: 'post',
    data
  })
}

export function finalExamGradeDelete(data) {
  return service({
    url: '/api/final_exam/grade/delete',
    method: 'post',
    data
  })
}

export function finalExamGradeSubmit(data) {
  return service({
    url: '/api/final_exam/grade/submit',
    method: 'post',
    data
  })
}

export function finalExamGradeFileSave(data) {
  return service({
    url: '/api/final_exam/file/save',
    method: 'post',
    data
  })
}
